import { isPlatformServer } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    Inject,
    Input,
    OnInit,
    PLATFORM_ID,
    ViewEncapsulation,
} from '@angular/core';
import { PassportProduct } from '@app/core/interfaces';
import { ScrollService } from '@app/core/scroll/scroll.service';
import { WINDOW } from '@inshared/shared/util';
import { Router } from '@angular/router';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-passport-insurances',
    templateUrl: './passport-insurances.component.html',
    styleUrls: ['./passport-insurances.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class PassportInsurancesComponent implements OnInit {
    @Input() public passportProducts?: PassportProduct[];

    public isListVisible: boolean = false;
    public itemsVisible: number;

    @HostListener('window:resize', ['$event'])
    public onResize(): void {
        this.getMaxIndex(false);
    }

    constructor(
        private scrollService: ScrollService,
        private router: Router,
        @Inject(WINDOW) private window: Window,
        @Inject(PLATFORM_ID) private platformId: object
    ) {}

    public ngOnInit(): void {
        this.getMaxIndex(this.isListVisible);
    }

    public getMaxIndex(visible: boolean): void {
        if (isPlatformServer(this.platformId)) {
            return;
        }
        const breakpoint = this.window
            .getComputedStyle(document.querySelector('body'), ':before')
            .getPropertyValue('content')
            .replace(/\"/g, '');

        if (!visible) {
            if (breakpoint === 'xs') {
                this.itemsVisible = 2;
            } else if (breakpoint === 'sm') {
                this.itemsVisible = 3;
            } else if (breakpoint === 'md' || breakpoint === 'lg' || breakpoint === 'xl') {
                this.itemsVisible = 4;
            }
        } else {
            this.itemsVisible = 99;
        }
    }

    public toggle(): boolean {
        const visible = (this.isListVisible = !this.isListVisible);
        this.getMaxIndex(visible);
        return false;
    }
    public selectInsurance(product: PassportProduct): boolean {
        if (product.purchased) {
            this.scrollService.scrollElementOffset(`#insurance-list-${product.productSequenceNumber}`);
            return false;
        }
    }
}
